module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onRegister": _vm.onRegister,
      "onSearch": _vm.getFuncionario,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHedad,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingTable
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18fd37d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/funcionario/index.vue
// module id = 1421
// module chunks = 45